import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const RATE_RECIPE_QUERY = gql`
mutation MyMutation($captchaResponse: String!, $rating: Int!, $recipeId: Int!) {
	__typename
	ratingCaptchaMutation(input: {captchaResponse: $captchaResponse, rating: $rating, recipeId:$recipeId}) {
	  data
	  success
	}
}  
`;
